import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Icon } from '../../../../../../../atoms'

export const ExtractQuoteItemsLoader = () => {
  return (
    <div className='flex h-full w-full flex-col items-center gap-10 p-10 text-center font-medium'>
      <p>
        <FormattedMessage
          id='ui.ExtractQuoteItemsButton.loading'
          defaultMessage='Extraction en cours, ne pas actualiser la page'
        />
      </p>

      <Icon name='book-sparkles' size={40} />

      <p className='text-xs text-grey-600'>
        <FormattedMessage
          id='ui.ExtractQuoteItemsButton.disclaimer'
          defaultMessage="Cette fonctionnalité est expérimentale. Merci de vérifier les résultats avant de valider le devis. {br} Si vous rencontrez un problème, nous vous prions de le signaler à l'équipe technique"
          values={{ br: <br /> }}
        />
      </p>
    </div>
  )
}
